import { createApp } from 'vue'
import httpPlugin from './plugin/http'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import VueViewer from 'v-viewer'
import dayjs from 'dayjs'

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.config.globalProperties.$dateFormat = function (dateStr, pattern = "YYYY-MM-DD HH:mm:ss") {
  if (!dateStr) return ''
  return dayjs(dateStr).format(pattern)
}

app.use(router)
app.use(ElementPlus)
app.use(VueViewer)
app.use(httpPlugin)

app.mount('#app')
